import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import underConstruction from "../images/underC.jpg";
import { useTranslation } from "react-i18next";


const MyPayroll = () => {
  const { t } = useTranslation();


    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <h1>This page is under construction</h1>
          <img src={underConstruction} style={{ width: "80%", height: "auto" }} />
        </div>
      );
};

export default MyPayroll;